export enum ClientWorkPackageStatus {
    ACTIVE = 'active',
    CLOSED = 'closed',
}
